import { FC } from 'react';
import styled, { css } from 'styled-components';
import { rotate360 } from '@animations/index';
import { EdnaWrapper, getCurrentTheme } from '@providers/index';
import Icon from '@components/Icon';
import { LoadingIconProps, LoadingstyledIconProps } from './types';

const animation = (disableAnimation: boolean) => {
  return disableAnimation
    ? 'none'
    : css`
        animation-name: rotate;
        animation: ${rotate360} 1.5s linear infinite;
      `;
};

const StyledIcon = styled(Icon)<LoadingstyledIconProps>`
  animation: ${(props) => animation(props.$disableAnimation as boolean)};
`;

const LoadingIcon: FC<LoadingIconProps> = ({
  color = 'primary',
  disableAnimation = false,
  size,
}: LoadingIconProps) => {
  const { colors } = getCurrentTheme();
  const iconColor = colors[color];

  return (
    <EdnaWrapper>
      <StyledIcon
        $disableAnimation={disableAnimation}
        color={iconColor}
        aria-label="Loading Icon"
        name="REFRESH"
        height={size}
        width={size}
      />
    </EdnaWrapper>
  );
};

export default LoadingIcon;
